import { mapGetters } from 'vuex'
import { checkEmail, checkPhone } from '@/utils/validate-rules'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['currentAccount']),
  },

  created() {
    const account =
      this.currentAccount ||
      (this.fromGuest ? this.$route.query.gi_address : '')
    this.initAccount(account)
  },

  methods: {
    back() {
      this.$router.push({
        path: '/login/' + this.type + '/account/',
        query: {
          ...this.$route.query,
        },
      })
    },
    forgotPassword() {
      let result = false
      if (this.type === 'phone') {
        result = checkPhone(this.form[this.type])
      } else if (this.type === 'email') {
        result = checkEmail(this.form[this.type])
      }

      if (result) {
        this.$store.commit('setCurrentAccount', this.form[this.type])
      }

      this.$router.push({
        path: '/reset_password/' + this.type + '/account',
        query: { ...this.$route.query },
      })
    },
  },
}
